import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';


const routes: CustomRoute = {
	path: '/transport-info',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'TransportInfo' */ './component')],
			render: ([TransportInfo]) => <TransportInfo />,
			onEnter: async ({ next }) => {
				console.log('on Enter TransportInfo');
				await next();
				console.log('on Enter TransportInfo / end');
			},
		},
	],
};

export default routes;
